import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    layers_verkenning: {
        loading: true,
        error: {},
        data: []
    },
    layersmetadata_verkenning: {
        loading: true,
        error: {},
        data: []
    },
    layersdata_verkenning: [],
    layerSettingsDropdown_verkenning: [],
    layersAkief_verkenning: [],
    overlayevents_verkenning: {
        // onMouseMove: (event) => console.log("==> mousemove", event)
    },
    infowindowlayer_verkenning: null,
    eventlisternerbind_verkenning: false,
    cleanbindedcomponent_verkenning: false
};

const toggleLayerSettingsDropdown_verkenning = (state, action) => {
    let tempActiveItems = [...state.layerSettingsDropdown_verkenning];
    if (tempActiveItems.indexOf(action.key) > -1) {
        tempActiveItems.splice(tempActiveItems.indexOf(action.key));
    } else {
        tempActiveItems.push(action.key);
    }
    return updateObject(state, { layerSettingsDropdown_verkenning: tempActiveItems });
};

const initKryLayerlys_verkenning = (state, action) => {
    return updateObject(state, {
        layersmetadata: { ...state.layersmetadata_verkenning, loading: true }
    });
};

const setLayerlys_verkenning = (state, action) => {
    let layerdataarr = [];
    for (let i = 0; i < state.layers_verkenning.data.length; i++) {
        layerdataarr.push({
            ...state.layers_verkenning.data[i],
            ...action.data.find(
                (itmInner) => itmInner.id === state.layers_verkenning.data[i].id
            ),
        });
    }
    return updateObject(state, { layersmetadata_verkenning: { ...state.layersmetadata_verkenning, data: action.data, loading: false }, layersdata_verkenning: layerdataarr });
};

const getLayerlysFailed_verkenning = (state, action) => {
    return updateObject(state, { layersmetadata_verkenning: { ...state.layersmetadata_verkenning, error: { error: action.error, easymessage: action.easymessage, status: action.status, message: action.message }, loading: false } });
};

const bindComponent_verkenning = (state, action) => {
    return updateObject(state, { cleanbindedcomponent_verkenning: false });
};

const kiesLayer_verkenning = (state, action) => {
    let cleanbindedcomponent = state.cleanbindedcomponent_verkenning;
    let tempActiveItems = [...state.layersAkief_verkenning];
    if (tempActiveItems.indexOf(action.key) > -1) {
        tempActiveItems.splice(tempActiveItems.indexOf(action.key));
        cleanbindedcomponent = true;
    } else {
        tempActiveItems.push(action.key);
        const newlayersmetadata = [...state.layersmetadata_verkenning.data];
        var mustIBind = false;
        for (var layer of newlayersmetadata) {
            if (layer.id === action.key) {
                for (var tipe of layer.layertipes) {
                    if (tipe.infooverlay) {
                        mustIBind = true;
                    }
                }
            }
        }
    }
    return updateObject(state, { cleanbindedcomponent_verkenning: cleanbindedcomponent, eventlisternerbind_verkenning: mustIBind, layersAkief_verkenning: tempActiveItems });
};

const setLayers_verkenning = (state, action) => {
    let newdata = [action.data];
    let historydata = [...state.layers_verkenning.data];
    for (var i = 0; i < newdata.length; ++i) {
        var updateItem = newdata[i];
        if (historydata.length > 0) {
            for (var j = 0; j < historydata.length; ++j) {
                if (historydata[j].id === updateItem.id) {
                    historydata[j] = updateItem;
                } else {
                    historydata.push(updateItem);
                }
            }
        } else {
            historydata = [...newdata];
        }
    }
    let layerdataarr = [];
    for (let i = 0; i < historydata.length; i++) {
        layerdataarr.push({
            ...historydata[i],
            ...state.layersmetadata_verkenning.data.find(
                (itmInner) => itmInner.id === historydata[i].id
            ),
        });
    }
    return updateObject(state, { layers_verkenning: { ...state.layers_verkenning, data: historydata, loading: false }, layersdata_verkenning: layerdataarr });
};

const removeLayer_verkenning = (state, action) => {
    var finaldata = state.layers_verkenning.data.filter((obj) => {
        return obj.id !== action.key;
    });
    let layerdataarr = [];
    for (let i = 0; i < finaldata.length; i++) {
        layerdataarr.push({
            ...finaldata[i],
            ...state.layersmetadata_verkenning.data.find(
                (itmInner) => itmInner.id === finaldata[i].id
            ),
        });
    }
    return updateObject(state, { layers_verkenning: { ...state.layers_verkenning, data: finaldata, loading: false }, layersdata_verkenning: layerdataarr });
}

const changeLayertipe_verkenning = (state, action) => {
    let cleanbindedcomponent = state.cleanbindedcomponent_verkenning;
    var tempoverlayevents;
    const newlayersmetadata = [...state.layersmetadata_verkenning.data];
    var mustIBind = false;
    for (var layer of newlayersmetadata) {
        if (layer.id === action.key) {
            for (var tipe of layer.layertipes) {
                if (tipe.type === action.tipe && tipe.key === action.layerkey) {
                    if (tipe.infooverlay) {
                        mustIBind = true;
                    }
                    tipe.active = true;
                } else {
                    tipe.active = false;
                    cleanbindedcomponent = true;
                }
            }
        }
    }
    let layerdataarr = [];
    for (let i = 0; i < state.layers_verkenning.data.length; i++) {
        layerdataarr.push({
            ...state.layers_verkenning.data[i],
            ...state.layersmetadata_verkenning.data.find(
                (itmInner) => itmInner.id === state.layers_verkenning.data[i].id
            ),
        });
    }
    return updateObject(state, { cleanbindedcomponent_verkenning: cleanbindedcomponent, eventlisternerbind_verkenning: mustIBind, layersmetadata_verkenning: { ...state.layersmetadata_verkenning, data: newlayersmetadata }, overlayevents_verkenning: { ...state.overlayevents_verkenning, ...tempoverlayevents }, layersdata_verkenning: layerdataarr });
}

const changeLayerFilter_verkenning = (state, action) => {
    const newlayersmetadata = [...state.layersmetadata_verkenning.data];
    for (var layer of newlayersmetadata) {
        if (layer.id === action.key) {
            for (var tipe of layer.filters) {
                if (tipe.type === action.tipe) {
                    tipe.filterdata = action.nuwewaarde;
                }
            }
        }
    }
    let layerdataarr = [];
    for (let i = 0; i < state.layers_verkenning.data.length; i++) {
        layerdataarr.push({
            ...state.layers_verkenning.data[i],
            ...newlayersmetadata.find(
                (itmInner) => itmInner.id === state.layers_verkenning.data[i].id
            ),
        });
    }
    return updateObject(state, { layersmetadata_verkenning: { ...state.layersmetadata_verkenning, data: newlayersmetadata }, layersdata_verkenning: layerdataarr });
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RESET_APP:
            return initialState;
        case actionTypes.LAYERSETTINGS_TOGGLE_VERKENNING:
            return toggleLayerSettingsDropdown_verkenning(state, action);
        case actionTypes.INIT_LAYERSLYS_VERKENNING:
            return initKryLayerlys_verkenning(state, action);
        case actionTypes.SET_LAYERSLYS_VERKENNING:
            return setLayerlys_verkenning(state, action);
        case actionTypes.GET_LAYERSLYS_FAILED_VERKENNING:
            return getLayerlysFailed_verkenning(state, action);
        case actionTypes.KIES_LAYER_VERKENNING:
            return kiesLayer_verkenning(state, action);
        case actionTypes.SET_LAYERSAKTIEF_VERKENNING:
            return setLayers_verkenning(state, action);
        case actionTypes.REMOVE_LAYER_VERKENNING:
            return removeLayer_verkenning(state, action);
        case actionTypes.CHANGE_LAYERTIPE_VERKENNING:
            return changeLayertipe_verkenning(state, action);
        case actionTypes.CHANGE_LAYERFILTER_VERKENNING:
            return changeLayerFilter_verkenning(state, action);
        case actionTypes.BIND_COMPONENT_VERKENNING:
            return bindComponent_verkenning(state, action);
        default:
            return state;
    }
};

export default reducer;